// deprecated, it's used only by residence
export const standalone = () => null;

export default standalone;
